

        jQuery(function() {
            var $module = jQuery('#m-1526066285533').children('.module');
            $module.find('.counter').counterUp({
                delay: 10,
                time: 1000
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1526063108402').children('.module');

        }); 
    